module.exports = __webpack_public_path__ + "static/media/left-arrow.04e82c7b.svg";